'use client'

import MainNav from '@/app/components/MainNav'
import DashboardCalculator from '@/app/components/calculators/DashboardCalculator'

export default function TransitionPlannerPage() {
  return (
    <div className="space-y-8 pb-16">
      <MainNav />
      <div className="mx-auto max-w-6xl">
        <DashboardCalculator />
      </div>
    </div>
  )
}
